<template lang="pug">
  .content(v-infinite-scroll="loadMore" :class="{'wide-catalog': isWide}" infinite-scroll-disabled="isInfiniteScrollDisabled" infinite-scroll-distance="3000")
    slot(name="left-sidebar")
    slot(name="above-title")
    .page-heading
      div(style="display: flex; align-items: baseline; grid-column-start: 1; grid-column-end: -2")
        slot(name="title")
        agv-ordering-selector(v-if='showOrdering'
          :sort-column.sync='sortColumn'
          :sort-direction.sync='sortDirection'
          :ordering-criteria="orderingCriteria"
          @changed="onOrderingChanged")
      .article-count(v-show="articles.length")
        | Показано {{filteredArticlesCount | decline(['изделие', 'изделия', 'изделий'])}}
      slot(name="warning")
    .catalog(v-show='showArticles || showBanner' :class="{'catalog-with-ads': doLimitedArticlesHaveAds}" style="height: fit-content")
      agv-ad-banner(v-if="showBanner" style="margin-bottom: 40px" :show-only-new="showOnlyNewBanners" :dominant-aggregator-kind-id="dominantAggregatorKindId")
      component(:is="article.isMagnet ? 'agv-magnet' : 'agv-article'"
        v-for="(article, index) in articlesWithMagnet"
        :key="article.renter_id + ':' + article.id"
        :article="article"
        :show-discount="showDiscounts"
        :town-id="article.town_id"
        :renter="getRenterById(article.renter_id)"
        :show-rating="true"
        :is-advertising="getIsAdvertising(article, index)"
        :show-like-button="true"
        :show-created-at="showCreatedAt")
    slot(name="right-sidebar")
</template>

<script>
  import _ from 'lodash'
  import Vue from 'vue'

  import CheckMark from 'Shared/sprites/check.svg'
  import Cross from 'Aggregator/sprites/cross.svg'
  import IconCrossSmall from 'Shared/sprites/icon-cross-small.svg'

  import AgvArticle from 'Aggregator/components/agv-article'
  import AgvOrderingSelector from 'Aggregator/components/agv-ordering-selector'
  import AgvRating from 'Aggregator/components/agv-rating'
  import AgvArticlesList from 'Aggregator/components/agv-articles-list'
  import AgvMagnet from 'Aggregator/components/agv-magnet'
  import AgvAdBanner from "Aggregator/components/agv-ad-banner.vue";

  let ORDERING_CRITERIA = [
    {name: 'price_with_discount', description: 'по цене', defaultDirection: 'asc'},
    {name: 'total_available', description: 'по запасу', defaultDirection: 'desc'},
    {name: 'size', description: 'по размеру', defaultDirection: 'desc'}
  ]

  export default {
    props: {
      articles: {
        type: Array,
        required: true
      },
      filteredArticlesCount: {
        type: Number,
        required: true
      },
      isLoadingArticles: {
        type: Boolean,
        required: true
      },
      showOrdering: {
        type: Boolean,
        required: true
      },
      showArticles: {
        type: Boolean,
        required: true
      },
      getIsAdvertising: {
        type: Function,
        required: true
      },
      renter: Object,
      magnetArticle: Object,
      showDiscounts: Boolean,
      showCreatedAt: Boolean,
      showBanner: Boolean,
      showOnlyNewBanners: Boolean,
      dominantAggregatorKindId: Number,
      isWide: {
        type: Boolean
      }
    },
    name: "agv-articles-list",
    data() {
      return {
        sortColumn: null,
        sortDirection: null,
        orderingCriteria: ORDERING_CRITERIA
      }
    },
    components: {
      AgvAdBanner,
      AgvMagnet,
      AgvRating,
      AgvArticle,
      AgvOrderingSelector,
      CheckMark,
      Cross,
      IconCrossSmall
    },
    created() {
      this.sortColumn = this.defaultSortColumn
      this.sortDirection = this.defaultSortDirection
    },
    computed: {
      isInfiniteScrollDisabled() {
        return this.articles.length < 42 ||
          this.isLoadingArticles ||
          (this.articles.length >= this.filteredArticlesCount)
      },
      doLimitedArticlesHaveAds() {
        return !!(_.find(_.take(this.articles, 4), a => a.ad_copy))
      },
      articlesWithMagnet() {
        if (!this.magnetArticle || this.articles.length < 9) {
          return this.articles
        }

        let result = _.clone(this.articles)
        result.splice(6, 0, this.magnetArticle)

        return result
      }
    },
    methods: {
      resetFiltersAndSorting() {
        this.sortColumn = null
        this.sortDirection = null
      },
      loadMore() {
        this.$emit('loadMore')
      },
      onOrderingChanged() {
        const ordering =  this.sortColumn && this.sortDirection  ? this.sortColumn + ' ' + this.sortDirection : null
        this.$emit('orderingChanged', ordering)
      },
      getRenterById(renterId) {
        return this.$store.state.rentersById[renterId]
      },
      orderBy: _.orderBy,
    }
  }
</script>

<style scoped>
  .content {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
  }

  .catalog {
    grid-template-columns: repeat(3, 1fr);
    display: grid;
  }

  .page-heading {
    grid-column-start: 2;
    grid-column-end: -1;
    grid-row-start: 1;

    display: grid;
    grid-template-columns: subgrid;
  }

  .catalog {
    grid-column-start: 2;
    grid-column-end: -2;
  }

  .content.wide-catalog .page-heading, .content.wide-catalog .catalog {
    grid-column-start: 1;
  }

  .content.wide-catalog .page-heading {
    grid-column-end: -1;
  }

  .content.wide-catalog .catalog {
    grid-template-columns: repeat(4, 1fr);
  }

  .article-count {
    width: 185px;
    font-size: 14px;
    color: #949494;
    white-space: nowrap;

    grid-column-start: -2;

    padding-left: 40px;
  }

  .catalog-with-ads {
    padding-top: 37px;
  }

  .order-count {
    margin-right: 20px;
    font-size: 14px;
    color: #4a4a4a;
  }

  .order-count::before {
    content: '★';
    color: #f6ac18;
    display: inline-block;
    margin-right: 5px;
  }
</style>
